import { definePreset } from '@primevue/themes';
import Aura from '@primevue/themes/aura';
const MainPanelTheme = definePreset(Aura, {
    semantic: {
        primary: {
            50: 'var(--primary-blur)',
            //100: '#f0c6ed',
            //200: '#e59cde',
            //300: '#d970cd',
            //400: '#c94ebd',
            500: 'var(--primary)'
            //600: '#7d2096',
            //700: '#69187e',
            //800: '#531268',
            //900: '#3b0c4c'
        },
        red: {
            50: '#ffe5ec',
            //100: '#ffcdd8',
            //200: '#ffa4b9',
            //300: '#fc7b9a',
            400: 'var(--red)'
            //500: '#f35d8c',
            //600: '#e1486f',
            //700: '#c23b5e',
            //800: '#a42e4d',
            //900: '#861f3d'
        },
        'primary-light': {
            //50: '#f1d5f8',
            //100: '#e5a8f0',
            //200: '#db7bf2',
            //300: '#d056f3',
            400: 'var(--primary-light)'
            //500: '#9a2bc1',
            //600: '#8020a3',
            //700: '#661681',
            //800: '#4c0f60',
            //900: '#330a40'
        },
        'primary-dark': {
            //100: '#e8cfe5',
            //200: '#d19fc9',
            //300: '#b970ae',
            400: 'var(--primary-dark)'
            //500: '#401249',
            //600: '#37103a',
            //700: '#2d0d2c',
            //800: '#240a1d',
            //900: '#1a070f'
        }
    },
    components: {
        tooltip: {
            background: 'var(--primary-dark)'
        },
        skeleton: {
            colorScheme: {
                light: {
                    background: 'var(--primary-dark)'
                }
            }
        },
        checkbox: {
            colorScheme: {
                light: {
                    hover: {
                        borderColor: 'var(--primary-color)'
                    },
                    checked: {
                        hover: {
                            background: 'var(--primary-hover)',
                            borderColor: 'var(--primary-hover)'
                        }
                    }
                }
            }
        },
        toggleswitch: {
            colorScheme: {
                light: {
                    checked: {
                        background: 'var(--p-green-600)',
                        hover: {
                            background: 'var(--p-green-700)'
                        }
                    },
                    width: '3.3rem',
                    height: '1.9rem',
                    handle: {
                        size: '1.4rem'
                    }
                }
            }
        },
        togglebutton: {
            colorScheme: {
                light: {
                    checked: {
                        background: 'var(--p-primary-600)',
                        color: 'var(--white)'
                    },
                    background: 'var(--p-primary-color)',
                    color: 'var(--white)',
                    hover: {
                        color: 'var(--white)',
                        background: 'var(--p-primary-hover-color)'
                    },
                    content: {
                        checked: {
                            background: 'var(--p-primary-600)'
                        }
                    }
                }
            }
        },
        button: {
            borderRadius: '8px',
            colorScheme: {
                light: {
                    primary: {
                        background: 'var(--primary)',
                        borderColor: 'var(--primary)',
                        color: 'var(--text-secondary)',
                        hover: {
                            background: 'var(--primary-hover)',
                            borderColor: 'var(--primary-hover)'
                        },
                        active: {
                            background: 'var(--primary-active)',
                            borderColor: 'var(--primary-active)'
                        }
                    },
                    danger: {
                        background: 'var(--red)',
                        borderColor: 'var(--red)',
                        color: 'var(--white)',
                        hover: {
                            background: 'var(--red-hover)',
                            borderColor: 'var(--red-hover)'
                        }
                    },
                    contrast: {
                        background: 'var(--primary-dark)',
                        borderColor: 'var(--primary-dark)',
                        hover: {
                            background: 'var(--primary-dark-hover)',
                            borderColor: 'var(--primary-dark-hover)'
                        }
                    },
                    secondary: {
                        background: 'var(--primary-light)',
                        borderColor: 'var(--primary-light)',
                        color: 'var(--text-secondary)',
                        hover: {
                            background: 'var(--primary-light-hover)',
                            borderColor: 'var(--primary-light-hover)',
                            color: 'var(--text-secondary)'
                        }
                    },
                    outlined: {
                        secondary: {
                            hover: {
                                background: 'var(--primary-light-hover)',
                                borderColor: 'var(--primary-light-hover)',
                                color: 'var(--text-secondary)'
                            },
                            active: {
                                background: 'var(--primary-light-active)',
                                borderColor: 'var(--primary-light-active)',
                                color: 'var(--text-secondary)'
                            }
                        },
                        success: {
                            background: 'var(--success)',
                            borderColor: 'var(--success)',
                            color: 'var(--success)'
                        }
                    }
                }
            }
        },
        tabs: {
            colorScheme: {
                light: {
                    nav: {
                        button: {
                            background: 'var(--primary-dark)',
                            color: 'var(--white)',
                            shadow: '0px 0px 10px 50px rgba(74, 21, 88, 0.6)'
                        }
                    },
                    tablist: {
                        background: 'transparent',
                        borderWidth: 0
                    },
                    tab: {
                        borderWidth: '0 0 4px 0',
                        borderColor: 'transparent',
                        color: 'var(--white)',
                        hover: {
                            color: 'var(--red)',
                            borderColor: 'var(--red)'
                        },
                        active: {
                            color: 'var(--red)',
                            borderColor: 'var(--red)'
                        }
                    }
                }
            }
        },
        floatlabel: {
            color: 'var(--text-primary)',
            fontWeight: '600',
            active: {
                color: 'var(--primary-color)',
                fontWeight: '600'
            },
            in: {
                input: {
                    padding: {
                        top: '1.1rem'
                    }
                }
            },
            focus: {
                color: 'var(--primary-color)'
            }
        },
        iftalabel: {
            colorScheme: {
                light: {
                    focus: {
                        color: 'var(--primary-color)'
                    },
                    input: {
                        padding: {
                            top: '1.1rem'
                        }
                    }
                }
            }
        },
        icon: {
            size: '1.2rem'
        },
        input: {
            color: 'var(--text-primary)'
        },
        inputtext: {
            focus: {
                borderColor: 'var(--primary-color)'
            },
            colorScheme: {
                light: {
                    borderRadius: 'var(--input-border-radius)'
                }
            }
        },
        inputgroup: {
            colorScheme: {
                light: {
                    addon: {
                        borderRadius: 'var(--input-border-radius)'
                    }
                }
            }
        },
        select: {
            colorScheme: {
                light: {
                    borderRadius: 'var(--input-border-radius)'
                }
            },
            option: {
                color: 'var(--text-primary)',
                selected: {
                    color: 'var(--primary)',
                    background: 'var(--primary-bg)',
                    focus: {
                        background: 'var(--primary-bg)',
                        color: 'var(--text-primary)'
                    }
                }
            },
            dropdown: {
                color: 'var(--text-primary)'
            },
            focus: {
                borderColor: 'var(--primary-color)'
            }
        },
        password: {
            icon: {
                color: 'var(--text-primary)'
            }
        },
        progressbar: {
            background: 'var(--primary-dark)',
            value: {
                background: 'var(--primary-color)'
            }
        },
        toast: {
            colorScheme: {
                light: {
                    info: {
                        background: 'color-mix(in srgb, var(--p-blue-800), transparent 15%)',
                        borderColor: 'var(--p-blue-800)'
                    },
                    success: {
                        background: 'color-mix(in srgb, var(--p-lime-600), transparent 15%)',
                        borderColor: 'var(--p-lime-600)'
                    },
                    warn: {
                        background: 'color-mix(in srgb, var(--p-yellow-800), transparent 15%)',
                        borderColor: 'var(--p-yellow-800)'
                    },
                    error: {
                        background: 'color-mix(in srgb, var(--p-red-800), transparent 15%)',
                        borderColor: 'var(--p-red-800)'
                    }
                }
            }
        },
        popover: {
            colorScheme: {
                light: {
                    background: 'var(--primary)',
                    borderColor: 'var(--red)',
                    color: 'var(--white)',
                    borderRadius: '10px'
                }
            }
        },
        radiobutton: {
            colorScheme: {
                light: {
                    hover: {
                        borderColor: 'var(--primary-color)'
                    },
                    icon: {
                        checked: {
                            color: 'var(--primary)',
                            hover: {
                                color: 'var(--primary-hover)'
                            }
                        }
                    },
                    checked: {
                        background: 'var(--success)',
                        borderColor: 'var(--success)',
                        hover: {
                            background: 'var(--button-success)',
                            borderColor: 'var(--button-success)'
                        }
                    }
                }
            }
        },
        fieldset: {
            colorScheme: {
                light: {
                    borderColor: 'var(--gray-light-400)',
                    background: 'var(--primary-dark)',
                    color: 'var(--white)',
                    legend: {
                        color: 'var(--white)',
                        background: 'var(--primary-dark)'
                    },
                    padding: '0 0.75rem 0.75rem 0.75rem'
                }
            }
        },
        datatable: {
            colorScheme: {
                light: {
                    header: {
                        cell: {
                            background: 'var(--primary-dark)',
                            color: 'var(--white)'
                        }
                    },
                    row: {
                        background: 'var(--primary)',
                        color: 'var(--white)',
                        striped: {
                            background: 'var(--primary-light)',
                            color: 'var(--white)'
                        }
                    }
                }
            }
        }
    }
});

export default MainPanelTheme;
